export enum RollupType {
    Summary,
    DimensionSummaries,
    HourlyBreakdown,
    SessionLengthBreakdown,
    RollupData,
    AppConcurrentSummary,
    Conversations,
    RewindPlays
}
